<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/scheme/02/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>方案</span>
                                <span>简介</span>
                            </div>
                            <p class="text">家庭养老床位是指以养老机构为依托，以社区养老服务中心为支点，把养老机构专业化的养老服务延伸到家庭，对家有失能老人的家庭开展适老化改造、专业护理、远程监测等养老服务</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>家庭养老床位</span>
                                <span>有什么痛点？</span>
                            </div>
                            <p class="text">普惠性养老机构床位总数不足，政府兜底的社会救助性质的老年福利院针对特定老年群体，设施设备完善、服务品质优良的中高端养老机构由于收费较高，广泛的中等收入的老人和家庭难以承担；因此，可供普通收入老人选择的养老机构总量不足。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-m-d-y-s page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="w-m-d-y-s-content">
                            <div class="title">
                                <span>我们的</span>
                                <span>优势?</span>
                            </div>
                            <auto-row class="max-size list flew-row-wrap">
                                <auto-col class="list-item" v-for="(item,index) of w_m_d_y_s_list" :key="index">
                                    <div class="cell">
                                        <img :src="item.icon" height="48" alt="">
                                        <div class="title">{{item.title}}</div>
                                        <p class="text">{{item.content}}</p>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>运营数据</span>
                                <span>可视化管理</span>
                            </div>
                            <p class="text">服务对象类型统计、能力评估统计、服务动态统计、预警统计、适老化设备统计等数据可视化展示。</p>
                            <img src="@/assets/image/scheme/02/pic-07.png" style="margin-top:60px;" width="85%" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="y-j-c-l page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="y-j-c-l-content">
                            <div class="title">
                                <span>预警处理流程</span>
                                <span>流程</span>
                            </div>
                            <img src="@/assets/image/scheme/02/pic-06.png" style="margin-top:60px;" width="100%" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/scheme/02/pic-01.png'),
                    // require('@/assets/image/scheme/02/pic-02.png'),
                    require('@/assets/image/scheme/02/pic-03.png'),
                    require('@/assets/image/scheme/02/pic-04.png'),
                    // require('@/assets/image/scheme/02/pic-05.png'),
                ],
                w_m_d_y_s_list:[
                    {title:'软硬件一体化',icon:require('@/assets/image/scheme/02/03.png'),content:'专门根据家庭养老床位项目智能化产品清单需求打造多类型智能设备。平台软件、APP应用、均为自主研发，软硬件无缝对接、无障碍兼容。'},
                    {title:'7*24小时数据',icon:require('@/assets/image/scheme/02/01.png'),content:'监控服务客服团队7*24小时全年无休的数据监控服务，响应并处理报警信息，突发情况紧急救助，为政府关注的老人、残疾人等弱势群体形成救援网络。'},

                    {title:'极简安装',icon:require('@/assets/image/scheme/02/04.png'),content:'改造无压力所有智能产品均采用无线、低功耗、极简安装设计,无需布线、破坏墙壁,入户改造快速安装,后期维护零压力。'},
                    {title:'全业务流程一站式管理',icon:require('@/assets/image/scheme/02/02.png'),content:'从用户分类建档、入户改造、感知预警、工单处理、机构运营全业务场景一站式管理；'},

                    {title:'数据安全',icon:require('@/assets/image/scheme/02/06.png'),content:'依靠安全的数据加密解密算法、多数据备份系统、阿里云加持等技术，保障数据不会被篡改、丢失和泄漏。'},
                    {title:'海量业务验证',icon:require('@/assets/image/scheme/02/05.png'),content:'深度调码各地区熜模式，政府政策，内置业务从实践来到实践中去。'}
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*.wrap{*/
    /*    background-color:#f0f2f5;*/
    /*    min-height:100vh;*/
    /*}*/
    /*.banner-box{*/
    /*    position:relative;*/
    /*}*/
    /*.banner-box img{*/
    /*    width:100%;*/
    /*    max-height:600px;*/
    /*    min-height:200px;*/
    /*    overflow:hidden;*/
    /*    vertical-align: middle;*/
    /*}*/

    /*.page-content{*/
    /*    padding-bottom:100px;*/
    /*    position: relative;*/
    /*    z-index:2;*/
    /*}*/
    /*.page-content-child:nth-child(2n+1){*/
    /*    background-color:#ffffff;*/
    /*}*/
    /*.page-content-child:nth-child(2n+2){*/
    /*background-color: #f9f9f9;*/
    /*}*/
    /*.page-content-box{*/
    /*    !* background-color:#fff; *!*/
    /*    !* border-radius:16px; *!*/
    /*    overflow:hidden;*/
    /*    !* margin-top:-100px; *!*/
    /*    min-height:500px;*/
    /*}*/

    /*@media screen and (max-width: 1200px){*/
    /*    .page-content .content-w{*/
    /*        padding-left:15px;*/
    /*        padding-right:15px;*/
    /*    }*/
    /*}*/

    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        /*padding-bottom:100px;*/
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(1),.page-content-child:nth-child(2),.page-content-child:nth-child(4),.page-content-child:nth-child(6),.page-content-child:nth-child(7){
        background-color: #FFFFFF;
    }
    .page-content-child:nth-child(3),.page-content-child:nth-child(5){
        background-color:#F9F9F9;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:150px 0 200px 0;
    }

    .f-a-j-j:nth-child(2) .f-a-j-j-content{
        padding:0 0 100px 0;
    }

    .f-a-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:115px 140px 0 140px;
        line-height: 1.6;
        transition: all .3s;
    }

    .f-a-j-j .text:hover{
        transform: translateY(-5px);
    }

    .s-q-y-l-g-l .s-q-y-l-g-l-content{
        text-align: center;
        padding:0 0 200px 0;
    }


    .s-q-y-l-g-l .list{
        width:calc(100% + 40px);
        text-align: center;
        margin-left: -20px;
        padding:0 10px;
    }

    .s-q-y-l-g-l .list-item{
        width:calc(33.33% - 40px);
        margin: 0 20px;
        margin-top:80px;
        text-align: center;
        transition: all .3s;
        height: 20vw;
        max-height: 200px;
        box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
    }

    .s-q-y-l-g-l .list-item .cell{
        padding:30px 20px 0 20px;
        text-align: left;
    }

    .s-q-y-l-g-l .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        margin-bottom:5px;
    }

    .s-q-y-l-g-l .list-item .cell .line{
        width:100px;
        height: 3px;
        background: #2FA8D0;
    }

    .s-q-y-l-g-l .list-item .cell .text{
        line-height: 1.6;
        padding-top:20px;
        font-size: 18px;
        color:#333333;
    }

    .s-q-y-l-g-l .list-item:hover{
        transform: translateY(-5px);
        box-shadow: 0px 8px 11px 0px rgba(65,61,61,0.23);
    }



    .w-m-d-y-s .w-m-d-y-s-content{
        text-align: center;
        padding:100px 0 150px 0;
        margin:0 60px;
    }

    .w-m-d-y-s .list{
        width:calc(100% + 100px);
        text-align: left;
        margin-left: -50px;
    }

    .w-m-d-y-s .list-item{
        width:calc(50% - 100px);
        margin: 0 50px;
        margin-top:120px;
        text-align: left;
        transition: all .3s;
    }

    .w-m-d-y-s .list-item:hover{
        transform: translateY(-5px);
    }

    .w-m-d-y-s .list-item .cell{
        text-align: left;
    }

    .w-m-d-y-s .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        padding-top:15px;
    }

    .w-m-d-y-s .list-item .cell .text{
        line-height: 1.6;
        padding-top:15px;
        font-size: 18px;
    }


    .f-f-j-y .f-f-j-y-content{
        text-align: center;
        padding:332px 0 100px 0;
    }

    .f-f-j-y .f-f-j-y-content .title-padding{
        margin-right:40px;
    }


    .y-j-c-l .y-j-c-l-content{
        text-align: center;
        padding:0 0 80px 0;
    }



    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:130px 0 180px 0;
        }
        .f-a-j-j .text{
            padding:95px 120px 0 120px;
        }


        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:0 0 160px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:70px;
            text-align: center;
            transition: all .3s;
            height: 20vw;
            max-height: 200px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:80px 0 130px 0;
        }


        .f-f-j-y .f-f-j-y-content{
            text-align: center;
            padding:300px 0 80px 0;
        }
    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 160px 0;
        }
        .f-a-j-j .text{
            padding:75px 100px 0 100px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:0 0 120px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:60px;
            text-align: center;
            transition: all .3s;
            height: 30vw;
            max-height: 200px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:60px 0 110px 0;
        }


        .f-f-j-y .f-f-j-y-content{
            text-align: center;
            padding:200px 0 60px 0;
        }
    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:90px 0 140px 0;
        }
        .f-a-j-j .text{
            padding:55px 10px 0 10px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:0 0 80px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:50px;
            text-align: center;
            transition: all .3s;
            max-height: auto!important;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:40px 0 90px 0;
        }

        .f-f-j-y .f-f-j-y-content{
            text-align: center;
            padding:100px 0 50px 0;
        }

        .f-f-j-y .f-f-j-y-content .title-padding{
            margin-right:15px!important;
        }

        .f-f-j-y .title span:nth-child(1){
            color:#333333;
            font-size: 36px;
            line-height: 1;
            letter-spacing: 6px;
        }
        .f-f-j-y .title span:nth-child(2){
            color:#2FA8D0;
            font-size: 36px;
            line-height: 1;
            letter-spacing: 6px;
        }
    }
</style>
